//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

export const SEARCH_FILTERS = {
  COLLECTION_CONTENT_FILTERS: 'collection-content-filters',
  COLLECTION_CONTENT_FILTERS_PROCESSED: 'collection-content-filters-processed',
  COLLECTION_CONTENT_FILTERS_QUICK_SEARCH:
    'collection-content-filters-quick-search',
  COLLECTION_CONTENT_FILTERS_SORT: 'collection-content-filters-sort',
  CONTENT_LIBRARY_SIDEBAR_FILTERS: 'content-library-sidebar-filters',
  CONTENT_LIBRARY_USERS_DROPDOWN_FILTERS:
    'content-library-users-dropdown-filters',
  CONTENT_SOCIAL_SEARCH_FILTERS: 'content-social-search-filters',
  STREAMS_FILTERS_SORT: 'streams-filters-sort',
  STREAM_FILTERS_MODERATION_STATUS: 'stream-filters-moderation-status',
  STREAM_FILTERS_MENTIONS_STATUS: 'stream-filters-mentions-status',
  STREAM_FILTERS_CONNECT_VENDOR: 'stream-filters-connect-vendor',
  STREAM_SOURCES: 'stream-sources',

  // Consumers shouldn't use this. Used to create a valid
  // initial value for SearchFilterService's BehaviorSubjects
  INITIAL_FILTER: 'initial',
} as const;
